import { createBrowserHistory } from "history";
//the browser history object
export default createBrowserHistory();
